import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Background, Title, Container, Content, Footer, Close, FullscreenToggle } from './styles';
import { Button } from '~components/button';

function Modal({ open, title, hide, actions, positive, negative, width, height, hideClose, allowFullscreen, children }) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  function handleHide() {
    setIsFullscreen(false);
    hide();
  }

  function handleIsFullscreen() {
    setIsFullscreen(!isFullscreen);
  }

  function buildActions(actions) {
    if (_.isEmpty(actions)) {
      return null;
    }
    return (_.map(actions, ({ label, action, type = 'button', disabled, primary, error , success }, index) => (
        <Button
          key={index}
          type={type}
          disabled={disabled}
          primary={primary}
          error={error}
          success={success}
          onClick={action}>
          {label}
        </Button>
      )));
  }

  function build() {
    if (!open) return null;

    return (
      <Background isOpen={open}>
        <Container fullscreen={isFullscreen} height={height} width={width}>
          {!hideClose &&
            <Close onClick={handleHide} />
          }
          {allowFullscreen === true && (
            <FullscreenToggle
              fullscreen={isFullscreen.toString()}
              onClick={handleIsFullscreen}
            />
          )}
          <Title>{title}</Title>
          <Content titleText={title} hideClose={hideClose}>{children}</Content>
          <Footer>
            {buildActions(actions)}
          </Footer>
        </Container>
      </Background>
    );
  }
  return ReactDOM.createPortal(build(), document.body);
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  allowFullscreen: PropTypes.bool,
  hideClose: PropTypes.bool,
  title: PropTypes.node,
  actions: PropTypes.array,
  hide: PropTypes.func.isRequired,
  width: PropTypes.string,
  height: PropTypes.string
};

Modal.defaultProps = {
  open: false,
  allowFullscreen: false,
  hideClose: false,
  actions: [],
  width: '80vw',
  height: '80vh'
};

export default Modal;
